// component-loader.js
// Load page components.
import _ from './dont-need-lodash.js';
import { components, syncNames } from '../../../components.js';

export default {

  load() {
    // run all sync components, run all async components that are on the page
    let $components = Array.prototype.slice.call(document.querySelectorAll('.component'));
    const classList = _.flatten($components.map(c => c.className.split(" ")));
    const listOfComponentsToRun = [];
    for (const c of syncNames) {
      listOfComponentsToRun.push(c);
    }
    if (classList && classList.length > 0) {
      for (const c of classList) {
        listOfComponentsToRun.push(c);
      }
    }
    for (const c of listOfComponentsToRun) {
      if (components[c]) {
        components[c]();
      }
    }
  },
};
